import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, CircleMarker, Popup, ZoomControl, AttributionControl, Pane } from 'react-leaflet';
import parse from 'html-react-parser';
import 'leaflet/dist/leaflet.css';
import StateOutlines from './StateOutlines';
import VtGeo from './VtGeo';
import UsdmOverlay from './UsdmOverlay';

export default function MarkerMaps(props) {
  const { selectedState, markers, mapTitle, geo=null, usdmOverlay=false, markerType="circle", mode } = props;
  const [ iconSize, setIconSize ] = useState(5);
  const [ leafletMap, setLeafletMap ] = useState(null);
  const [ markersOnMap, setMarkersOnMap ] = useState(null);
  const [ geofile, setGeofile ] = useState(null);

  const bounds = [[42.72694, -73.43545], [45.01597, -71.49364]];
  const maxBounds = [[42.4, -74.1], [45.3, -70.8]];
  const minZoomLevel = 7;
  const statesOnMap = ['vt','ny','nh','me','ma','ri','ct','qc'];

  const geoStyle_unselected = {color: "gray", weight:0.1, fillColor: "gray", fillOpacity: usdmOverlay ? 0.0 : 0.3};
  const geoStyle_selected = {color: "darkgreen", weight:1, fillColor: "white", fillOpacity: 0.0};
  const geoStyle_substate= {color: "darkblue", weight:0.25, fillColor: "white", fillOpacity: usdmOverlay ? 0.0 : 0.2};
  const geoStyle_county= {color: "darkblue", weight:0.75, fillColor: "white", fillOpacity: usdmOverlay ? 0.0 : 0.2};

  useEffect(() => {
    if (leafletMap) {
      leafletMap.on('zoomend', () => {
        setIconSize(leafletMap.getZoom() - 2);
      })
    }
  }, [leafletMap] );

  useEffect(() => {
    setMarkersOnMap([]);        //clear previous
    setTimeout(() => {
      setMarkersOnMap(markers)  //add a little time to allow clear
    }, 100)
  }, [markers]);

  const county_outlines = require('./geo/VT_County.json');
  
  useEffect(() => {
    if (geo) {
      switch (geo) {
        case "basin":
          setGeofile(require('./geo/VT_Subbasin_HUC8.json'));
          break;
        case "town":
        case "towncounty":
          setGeofile(require('./geo/VT_Town.json'));
          break;
        case "county":
          setGeofile(require('./geo/VT_County.json'));
          break;
            default:
        setGeofile(null);
      }
    };
  }, [geo]);

  return (
    <div className="marker-map-container">
      <MapContainer
        className="marker-map"
        ref={setLeafletMap}
        bounds={bounds}
        maxBounds={maxBounds}
        minZoom={minZoomLevel}
        scrollWheelZoom={false}
        attributionControl={false}
        zoomControl={false}>

        <TileLayer
          url='https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png'
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
          crossOrigin={true}
          onTileLoadStart={te => { te.tile.setAttribute('alt', 'Leaflet map image');}}
        />

        <AttributionControl position="bottomright" prefix={"<a href='https://leafletjs.com'>Leaflet</a>"} />
        <ZoomControl position="bottomright" />
        

        {usdmOverlay &&
          <Pane name="usdm" style={{ zIndex: 500 }}>
            <UsdmOverlay 
              mode={mode}
            />
          </Pane>
        }  

        <Pane name="thisState" style={{ zIndex: 510 }}>
          <StateOutlines 
            statesOnMap={[selectedState]}
            mapStyle={geoStyle_selected}
          />
        </Pane>

        <Pane name="otherStates" style={{ zIndex: 510 }}>
          <StateOutlines 
            statesOnMap={statesOnMap.filter(item => item !== selectedState)}
            mapStyle={geoStyle_unselected}
          />
        </Pane> 
        
        {geo &&
          <Pane name="geolines" style={{ zIndex: 520 }}> 
            <VtGeo 
              geo={geofile}
              mapStyle={geoStyle_substate}
            />
          </Pane>
        }

        {geo === 'towncounty' &&
          <Pane name="cntylines" style={{ zIndex: 520 }}> 
            <VtGeo 
              geo={county_outlines}
              mapStyle={geoStyle_county}
            />
          </Pane>
        }

        <Pane name="markers" style={{ zIndex: 530 }}>
          {markersOnMap && markerType === 'circle' &&
            markersOnMap.map((m, i) => (
              <CircleMarker 
                key={i+"marker"}
                center={m.position}
                radius={iconSize}
                {...{fillColor: m.fillColor, color: "black", weight: 1, fillOpacity: 1}}
              >
                {m.data &&
                  <Popup pane="popupPane" style={{ zIndex: 1000 }}>
                    <div className="marker-map-popup">{parse(m.data)}</div>
                  </Popup>
                }
              </CircleMarker>
            ))
          }
        </Pane>
        <span className="marker-map-title">{parse(mapTitle)}</span>
      </MapContainer>
    </div>
  )
}
